<app-header-modal [color]="'secondary-2'" [title]="titleModal"></app-header-modal>

<mat-tab-group mat-align-tabs="center">
  <mat-tab label="Detalhes da Ordem">
    <app-in-details-buy-order [data]="order"></app-in-details-buy-order>
  </mat-tab>
  <mat-tab label="Histórico">
    <app-order-history [orderId]="order?.id"></app-order-history>
  </mat-tab>
</mat-tab-group>